<template>
  <DiagramBlock
    title="Members"
    emptyDesc="There is no members statistics data available yet"
    :diagramItems="statistic"
    :loading="loading"
    @details="clickToDetails"
    @legendClick="legendClick"
    @chartClick="chartClick"
  />
</template>

<script>
import apiClient from '@/services/axios'
import DiagramBlock from '@/views/apps/referral-program/referral-programs/components/DiagramBlock'
import { getMembersStatusColors } from '@/views/apps/referral-program/referral-programs/composables/useGetMembersStatusColors.js'
import { getErrorMessage } from '@/views/apps/fortune-wheel/composables/useGetErrorMessage.js'

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL

export default {
  components: {
    DiagramBlock,
  },
  data: () => ({
    programId: null,
    items: [],
    statistic: [],
    loading: true,
  }),
  methods: {
    clickToDetails() {
      this.$router.push(`/referral/programs/${this.programId}/members`)
    },
    getParamsPrefix(name) {
      const sector = this.statistic.find(stat => stat.name === name)
      const includesAffiliate = sector.items.find(item => item.name === 'Affiliate')
      if (includesAffiliate) {
        return 'aff'
      }
      return 'ref'
    },
    legendClick(param) {
      const prefix = this.getParamsPrefix(param)
      this.$router.push(`/referral/programs/${this.programId}/members?${prefix}-status=${param}`)
    },
    chartClick({ name }) {
      const prefix = this.getParamsPrefix(name)
      this.$router.push(`/referral/programs/${this.programId}/members?${prefix}-status=${name}`)
    },
    getColor(status) {
      return getMembersStatusColors(status)
    },
    setStatistic() {
      if (!this.items?.length) {
        return
      }
      this.statistic = this.items.map(item => {
        return {
          name: item.name,
          value: item.value,
          items: item.items,
          itemStyle: { color: this.getColor(item.name) },
        }
      })
    },
    async getMembersStatistics() {
      this.programId = this.$route.params.id

      try {
        this.loading = true
        const url = `${referralApiUrl}/referral-programs/${this.programId}/members/statistic`
        const response = await apiClient.get(url)
        const { data } = response?.data
        if (data) {
          this.items = data
          this.setStatistic()
          return
        }
        getErrorMessage(response?.data)
      } catch (e) {
        this.$notification.error({
          message: e?.message ? e.message : 'Error',
        })
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.getMembersStatistics()
  },
}
</script>
